import { POST, GET } from '../_helpers';

// eslint-disable-next-line no-unused-vars
import { json1, json2, json4, C } from '../constants';
import {GeoLocation} from "../services/GeoLocation/GeoLocation";

const _setAlert = alerts => dispatch => {
    alerts.forEach(alert => dispatch(addAlert(alert)));
};

const _addAlert = makeActionCreator('ADD_ALERT', 'alert');
const _removeAlert = makeActionCreator('REMOVE_ALERT', 'id');
const _setCurrentAction = makeActionCreator('SET_CURRENT_ACTION', 'currentAction');
const _setUserData = makeActionCreator('SET_USER_DATA', 'userData');
const _setAppStatus = makeActionCreator('SET_APP_STATUS', 'appStatus');
const _setDialog = makeActionCreator('SET_DIALOG', 'dialog');
const _setSearchDialog = makeActionCreator('SET_SEARCH_DIALOG', 'searchDialog');
const _setSearchResult = makeActionCreator('SET_SEARCH_RESULT', 'searchResult');
const _addHistoryPage = makeActionCreator('ADD_HISTORY_PAGE', 'history');
const _setPreviousPage = makeActionCreator('SET_PREVIOUS_PAGE', 'history');
const _updateHistory = makeActionCreator('UPDATE', 'history');
const _clearHistory = makeActionCreator('CLEAR', 'history');
const _goBack = makeActionCreator('GO_BACK', 'history');

export const updateUserData = ({ name, value, label }) => (dispatch, getState) => {
    const { userData } = getState();

    // console.log("updateUserData name: ", name);
    // console.log("updateUserData value: ", value);
    // console.log("updateUserData label: ", label);

    dispatch(_setUserData({
        ...userData,
        blocks: userData.blocks.map(block => ({
            ...block,
            value: block.name === name ? value : block.value,
            label: block.name === name ? label : block.label,
            elements: block.elements.map(element => ({
                ...element,
                blocks: element.blocks ? element.blocks.map(block2 => ({
                    ...block2,
                    value: block2.name === name ? value : block2.value,
                    label: block2.name === name ? label : block2.label
                })) : []
            }))
        })
        )
    }));
};

export const restartPoll = () => (dispatch) => {
    dispatch(_setUserData(null));
    dispatch(_clearHistory());
    dispatch(_getBlockByUrl());
};

export const goBack = () => (dispatch, getState) => {
    const { history } = getState();

    let newHistory = history[history.length - 2];

    dispatch(_setUserData(newHistory));
    dispatch(_goBack());

    // Эмулируем загрузку. Т.к. после загрузки происходит Scroll Up в компоненте AppScrollView
    dispatch(_setAppStatus('loading'));
    setTimeout(() => {
        dispatch(_setAppStatus('loaded'));
    }, 500);
};

export const setDialog = (label, value) => (dispatch) => {
    dispatch(_setDialog({
        visible: true,
        label,
        value
    }));
};

export const setSearchDialog = ({ block, value }) => (dispatch) => {
    dispatch(_setSearchDialog({
        visible: true,
        block,
        value
    }));
};

export const deleteDialog = () => (dispatch) => {
    dispatch(_setDialog({}));
};

export const deleteSearchDialog = () => (dispatch) => {
    dispatch(_setSearchDialog({}));
};

export const setUserData = _setUserData;
export const addHistoryPage = _addHistoryPage;
export const setPreviousPage = _setPreviousPage;


export const search = ({ text, lib }) => (dispatch) => {

    if (text.length < 2) {
        return;
    }

    let path = 'http://umkb.socmedica.com/api/search';

    dispatch(_setAppStatus('loading'));
    return GET({
        path,
        data: {
            text,
            lib,
            chain: -2
        },
        success: data => {
            dispatch(_setSearchResult(data.concepts));
            // console.log(data);
        },
        fail: (data) => {
            // console.log('logged', data);
        },
        always: (data) => {
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};
const _getBlockByUrl = (path) => async (dispatch, getState) => {
    const {userData, history, appRegion} = getState();

    // path = 'https://umkb.socmedica.com/corona_stop_json/breath_test.json';
    // path = 'https://umkb.socmedica.com/corona_stop_json/start.json';
    // path = 'https://umkb.socmedica.com/corona_stop_json/EMPTY.json';


    /**
     shitfix
     TREE_SELECT приходят числа, а ответ надо вернуть строками
     */

    let newUserData = {
        ...userData,
        blocks: userData.blocks.map(block => {
            if (block.type === "TREE_SELECT") {
                return {
                    ...block,
                    value: block.value.map(v => "" + v)
                };
            }
            return block;
        }),
        geoLocation: await GeoLocation,
        lang: appRegion.toLowerCase()
    };
    // <==shitfix

    dispatch(_setAppStatus('loading'));

    return POST({
        path: path || C.REQUEST_PATH,
        data: newUserData,
        success: data => {

            let newData = {...data};

            let backButtonElement = {
                "label": data.lang === "ru" ? "Назад" : "Back",
                "action": {"type": "goBack"}
            };

            if (newData.blocks) {

                // required shitfix
                newData = {
                    ...newData,
                    blocks: newData.blocks.map(block => {

                        return {
                            ...block,
                            required: block.type === "RADIOBUTTON" && block.name !== "6=>250037814" ? true : block.required
                        };
                    })
                };

                // add BACK Button
                let blocks = newData.blocks || [];
                let lastBlock = blocks[blocks.length - 1] || {};
                // alert(JSON.stringify(newData));
                if (lastBlock.type === 'BUTTON' && history.length) {
                    lastBlock.elements.unshift(backButtonElement);
                }
                // alert(JSON.stringify(newData));
                //
                dispatch(_setUserData(newData));
                dispatch(_updateHistory(userData));
                dispatch(_addHistoryPage(newData));
            }
        },
        fail: (data) => {
            console.log('logged', data);
        },
        always: (data) => {
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const addAlert = alert => (dispatch, getState) => {
    const { alerts: prevAlerts } = getState();

    // Если такой же алерт уже есть - не добавляем.
    // Спорное решение, но оно было в предыдущей реализации, поэтому оставил.
    if (prevAlerts.some(prevAlert => prevAlert.message === alert.message && prevAlert.level === alert.level)) {
        return;
    }

    alert.id = alert.id ? alert.id : (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);

    dispatch(_addAlert(alert));
};

export const removeAlert = _removeAlert;
export const getBlockByUrl = _getBlockByUrl;


export const setCurrentAction = currentAction => (dispatch) => {
    let hash = window.location.hash || '#';

    hash = hash.slice(1);
    let params = new URLSearchParams(hash);
    let action = params.get("action");

    if (currentAction !== action) {
        window.location.hash = '#action=' + currentAction;
    }
    dispatch(_setCurrentAction(currentAction));
};

export const setAlert = _setAlert;

export const _setRegion = (region) => {
    return ({
        type: 'SET_APP_REGION',
        appRegion: region
    })
}
export const setAppRegion = (region) => (dispatch) =>{
    dispatch(_setRegion(region));
    dispatch(_setUserData(null));
    dispatch(_clearHistory());
    dispatch(_getBlockByUrl());


}






;











////////////////////////////////////////////////////////



export const checkAuthKey = () => (dispatch) => {
    let authkey = localStorage.getItem('authkey');

    if (!authkey) {
        dispatch(_setCurrentAction('login'));
        return;
    }

    dispatch(_setAppStatus('loading'));
    return GET({
        path: `https://cs.socmedica.com/api/user/authCheck`,
        data: {
            authkey,
            key: C.AUTH_SERVICE_KEY
        },
        success: data => {
            console.log('logged', data);
            dispatch(_setCurrentAction('interface'));
            dispatch(_getBlockByUrl());
        },
        fail: () => {
            if (localStorage.getItem('authkey') === 'testKey') {
                dispatch(_setCurrentAction('interface'));
            } else {
                dispatch(_setCurrentAction('login'));
            }
        },
        always: (data) => {
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const sendEmailConfirm = data => (dispatch) => {
    // const { editedItem } = getState();
    dispatch(_setAppStatus('loading'));

    return POST({
        path: `https://cs.socmedica.com/api/registration/confirmemail`,
        data: {
            code: data.code,
            email: data.email,
            key: C.AUTH_SERVICE_KEY
        },
        success: () => {
            // if (data && data.alerts) {
            //     dispatch(_setAlert(data.alerts));
            // }
            dispatch(_setCurrentAction('confirmSuccess'));
            // if (data.authkey) {
            //     localStorage.setItem('authkey', data.authkey);
            //     dispatch(_setCurrentAction('confirmSuccess'));
            // }
            // dispatch(_setCurrentAction('confirmSuccess'));
        },
        fail: alerts => dispatch(_setAlert(alerts)),
        always: (data) => {
            // console.log(data);
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const sendGetEmailConfirm = data => (dispatch) => {
    // const { editedItem } = getState();
    dispatch(_setAppStatus('loading'));

    return POST({
        path: `https://cs.socmedica.com/api/registration/getconfirmemail`,
        data: {
            email: data.email,
            key: C.AUTH_SERVICE_KEY
        },
        success: () => {
            // if (data && data.alerts) {
            //     dispatch(_setAlert(data.alerts));
            // }
            dispatch(_setCurrentAction('getConfirmSuccess'));
            // if (data.authkey) {
            //     localStorage.setItem('authkey', data.authkey);
            //     dispatch(_setCurrentAction('confirmSuccess'));
            // }
            // dispatch(_setCurrentAction('confirmSuccess'));
        },
        fail: alerts => dispatch(_setAlert(alerts)),
        always: (data) => {
            // console.log(data);
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const sendRegistration = data => (dispatch) => {
    dispatch(_setAppStatus('loading'));

    return POST({
        path: `https://cs.socmedica.com/api/registration/send`,
        data: {
            ...data,
            key: C.AUTH_SERVICE_KEY
        },
        success: () => {
            // if (data && data.alerts) {
            //     dispatch(_setAlert(data.alerts));
            // }
            dispatch(_setCurrentAction('registrationSuccess'));
        },
        fail: alerts => dispatch(_setAlert(alerts)),
        always: (data) => {
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const sendLogin = data => (dispatch) => {
    dispatch(_setAppStatus('loading'));

    return POST({
        path: `https://cs.socmedica.com/api/user/authorization`,
        data: {
            ...data,
            key: C.AUTH_SERVICE_KEY
        },
        success: data => {
            // if (data && data.alerts) {
            //     dispatch(_setAlert(data.alerts));
            // }
            if (data.authkey) {
                localStorage.setItem('authkey', data.authkey);
                dispatch(_setCurrentAction('interface'));
            }
        },
        fail: () => {
            // dispatch(_setAlert(alerts));
            // if (localStorage.getItem('testing') === '1') {
            //     localStorage.setItem('authkey', 'testKey');
            //     dispatch(_setCurrentAction('interface'));
            // }
        },
        always: (data) => {
            if (data && data.alerts) {
                dispatch(_setAlert(data.alerts));
            }

            dispatch(_setAppStatus('loaded'));
        }
    });
};

export const sendLogout = () => () => {
    return GET({
        path: `https://cs.socmedica.com/api/user/authexit`,
        data: {
            authkey: localStorage.getItem('authkey'),
            key: C.AUTH_SERVICE_KEY
        },
        always: () => {
            // if (data && data.alerts) {
            //     dispatch(_setAlert(data.alerts));
            // }
            localStorage.setItem('authkey', '');
            window.location.reload(false);
            // dispatch(_setCurrentAction('login'));
        }
    });
};


///////////////////////////////////////////////////////




























function makeActionCreator(type, ...argNames) {
    return function (...args) {
        let action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index];
        });
        return action;
    };
}